__webpack_require__.p = "https://assets.worldcubeassociation.org/nextjs/69aa07076100ec096cf1f84a6a5a06e45ddf48a9/_next/";